import {Body2} from '@ui/atoms/typography';
import {useDropDown} from '@hooks';
import {FiChevronDown} from 'react-icons/fi';
import {CalenderIcon} from '@ui/atoms/icons/calender-icon';
import {CycleOccurrence} from '../../team-management/team-management.utils';
import {formatSendOptionLabel} from '../team-feed.utils';

interface SendSelectorDropdownProps {
  occurrences: CycleOccurrence[];
  selectedOccurrence?: CycleOccurrence;
  onSelect: (key: string) => void;
}

export const SendSelectorDropdown = ({
  occurrences,
  selectedOccurrence,
  onSelect,
}: SendSelectorDropdownProps) => {
  const {handleOpen, ref, handleClose, open} = useDropDown();
  const selectedIndex = occurrences.findIndex(
    (occurrence) => occurrence.key === selectedOccurrence?.key,
  );
  const selectedLabel = selectedOccurrence
    ? formatSendOptionLabel(selectedOccurrence, selectedIndex === 0)
    : 'No sends available';

  return (
    <div ref={ref} className="relative w-full">
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        disabled={!occurrences.length}
        onClick={(event) => handleOpen(event)}
        className="flex w-full items-center justify-between gap-3 rounded-[10px] border border-borderDark bg-white px-4 py-3 text-left disabled:cursor-not-allowed disabled:bg-backgroundDark">
        <span className="flex min-w-0 items-center gap-3">
          <CalenderIcon />
          <Body2 kind="textDark" weight="semibold" className="truncate">
            {selectedLabel}
          </Body2>
        </span>
        <FiChevronDown aria-hidden="true" />
      </button>

      {open && (
        <div
          role="listbox"
          className="absolute left-0 top-full z-10 mt-2 max-h-[232px] w-full overflow-y-auto rounded-[10px] border border-borderLight bg-white p-2 shadow-lg">
          {occurrences.map((occurrence, index) => (
            <button
              type="button"
              role="option"
              aria-selected={occurrence.key === selectedOccurrence?.key}
              key={occurrence.key}
              onClick={() => {
                onSelect(occurrence.key);
                handleClose();
              }}
              className={`w-full rounded-lg px-3 py-2 text-left hover:bg-backgroundDark ${
                occurrence.key === selectedOccurrence?.key
                  ? 'bg-backgroundDark'
                  : 'bg-white'
              }`}>
              <Body2 kind="textBody">
                {formatSendOptionLabel(occurrence, index === 0)}
              </Body2>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
